module.exports = {
  InstantSearch: () => null,
  SearchBox: () => null,
  Hits: () => null,
  DynamicWidgets: () => null,
  ClearRefinements: () => null,
};
